import React, { useEffect, useState } from "react";
import AccordionTable from "../../../../components/accordion/AccordionTable";
import { Box, Grid, MenuItem, Tooltip, Typography } from "@mui/material";

import { InputValueProjectForm } from "./domain";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import InputTextField from "../../../../components/input/inputTextField";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { useTranslation } from "react-i18next";
import FilterSelect from "../../../../components/select/filterSelect";
import { alertActive, alertSuccess } from "../../../../components/alert/swal";
import { YearsApi } from "../../../../api/yeas/years.api";
import InputTextMask from "../../../../components/input/inputTextMask";

interface IProjectFormProps {
  inputValue: InputValueProjectForm;
  setInputValue: React.Dispatch<React.SetStateAction<InputValueProjectForm>>;
  disabled?: boolean;
}

const SpendingInfoForm: React.FC<IProjectFormProps> = ({
  inputValue,
  setInputValue,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const [dataYears, setDataYears] = useState<any[]>([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>("ADD");

  const [inputValueSpendingInfo, setInputValueSpendingInfo] = useState<any>({
    spending_info_id: "",
    spending_info_month: "",
    spending_info_year: "",
    spending_info_value: "",
  });

  const fileHeaders = [
    {
      key: "index",
      label: "ลำดับ",
      width: 1,
      align: "center" as const,
      render: (value: any, rowData: any, rowIndex: number) => (
        <Typography variant="body2">{rowIndex + 1}</Typography>
      ),
    },
    {
      key: "spending_info_month",
      label: "เดือนที่ใช้",
      width: 3,
      render: (value: string, rowData: any) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title={value}>
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {getMonthName(value)}
            </Typography>
          </Tooltip>
        </Box>
      ),
    },
    {
      key: "spending_info_year",
      label: "ปีงบปะมาณ",
      width: 3,
      render: (value: string, rowData: any) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title={value}>
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {+value}
            </Typography>
          </Tooltip>
        </Box>
      ),
    },
    {
      key: "spending_info_value",
      label: "จำนวนเงิน",
      width: 3,
      align: "center" as const,
    },
  ];

  const fetchGetYears = async () => {
    const res = await YearsApi.getYears();
    const data = res.data;
    if (data.status < 300) {
      setDataYears(data.data);
    } else {
      setDataYears([]);
    }
  };

  useEffect(() => {
    fetchGetYears();
  }, []);

  const handleInputChange = (key: any, value: any) => {
    setInputValueSpendingInfo((prev: any) => ({ ...prev, [key]: value }));
  };

  const handleAddItem = () => {
    const newSpendingInfo = {
      spending_info_id:
        inputValueSpendingInfo.spending_info_id ?? new Date().getTime(),
      spending_info_month: inputValueSpendingInfo.spending_info_month,
      spending_info_year: inputValueSpendingInfo.spending_info_year,
      spending_info_value: inputValueSpendingInfo.spending_info_value,
    };

    setInputValue((prev) => ({
      ...prev,
      spendingInfo: [...prev.spendingInfo, newSpendingInfo],
    }));

    alertSuccess("ข้อมูลการใช้เงิน เรียบร้อย", undefined, undefined, () => {
      setShowModal(false);
    });

    // alertError("ข้อมูลการใช้เงิน ไม่สำเร็จ");
  };

  // const handleEditItem = (
  //   id: number,
  //   updatedData: Partial<{ name: string; value: string }>
  // ) => {
  //   setInputValue((prev) => ({
  //     ...prev,
  //     spendingInfo: prev.spendingInfo.map((item) =>
  //       item.id === id ? { ...item, ...updatedData } : item
  //     ),
  //   }));
  //   setShowModal(false);
  // };

  const handleDeleteItem = (_: any, index: number) => {
    alertActive(
      "ลบข้อมูลการใช้เงิน",
      "ท่านต้องการลบข้อมูลการใช้เงิน ใช่หรือไม่",
      undefined,
      undefined,
      async () => {
        setInputValue((prev) => ({
          ...prev,
          spendingInfo: prev.spendingInfo.filter(
            (_, i) => i !== index
          ),
        }));
        setShowModal(false);
      }
    );
  };

  const monthOptions = [
    { name: "มกราคม", value: "1" },
    { name: "กุมภาพันธ์", value: "2" },
    { name: "มีนาคม", value: "3" },
    { name: "เมษายน", value: "4" },
    { name: "พฤษภาคม", value: "5" },
    { name: "มิถุนายน", value: "6" },
    { name: "กรกฎาคม", value: "7" },
    { name: "สิงหาคม", value: "8" },
    { name: "กันยายน", value: "9" },
    { name: "ตุลาคม", value: "10" },
    { name: "พฤศจิกายน", value: "11" },
    { name: "ธันวาคม", value: "12" },
  ];

  const getMonthName = (value: string | number | undefined) => {
    return (
      monthOptions.find((month) => month.value === String(value))?.name || "-"
    );
  };


  const is_edit = mode == 'EDIT'

  return (
    <>
      {showModal && (
        <ModalCustom
          open
          title={is_edit ? "รายละเอียดข้อมูลการใช้เงิน" : "เพิ่มข้อมูลการใช้เงิน"}
          subTitle={t("")}
          onClose={() => {
            setShowModal(false);
            setMode("");
            setInputValueSpendingInfo({
              spending_info_id: "",
              spending_info_month: "",
              spending_info_year: "",
              spending_info_value: "",
            })
          }}
          component={
            <div className="w-full">
              <section className="w-full mt-10">
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{
                      alignSelf: "end",
                    }}
                  >
                    <FilterSelect
                      disabled={is_edit}
                      value={inputValueSpendingInfo.spending_info_month ?? ""}
                      labelId="เดือนที่ใช้-id"
                      selectId="เดือนที่ใช้-select-id"
                      heading="เดือนที่ใช้"
                      required
                      options={[...monthOptions].map(
                        (item: any, index: number) => (
                          <MenuItem value={item?.value} key={index + 1}>
                            {item?.name}
                          </MenuItem>
                        )
                      )}
                      onchange={(e: any) => {
                        handleInputChange(
                          "spending_info_month",
                          e.target.value
                        );
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{
                      alignSelf: "end",
                    }}
                  >
                    <InputTextMask
                      mode="amount"
                      heading={"จำนวนเงิน"}
                      placeholder={"จำนวนเงิน"}
                      value={inputValueSpendingInfo.spending_info_value ?? ""}
                      onChange={(e) =>
                        handleInputChange("spending_info_value", e.target.value)
                      }
                      required
                      helperText={""}
                      disabled={is_edit}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{
                      alignSelf: "end",
                    }}
                  >
                    <FilterSelect
                      value={inputValueSpendingInfo.spending_info_year ?? ""}
                      labelId="ทุกปีงบปะมาณ-id"
                      selectId="ทุกปีงบปะมาณ-select-id"
                      required
                      disabled={is_edit}
                      heading="ทุกปีงบปะมาณ"
                      options={[{ year: "ทุกปีงบปะมาณ" }, ...dataYears].map(
                        (item: any, index: number) => (
                          <MenuItem value={item?.year} key={index + 1}>
                            {item?.year}
                          </MenuItem>
                        )
                      )}
                      onchange={(e: any) =>
                        handleInputChange("spending_info_year", e.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </section>

              <div className="mt-6 w-full flex justify-center gap-4 items-center">
                <span>
                  <ButtonPrimary
                    mode="cancel"
                    buttonName={t("BUTTON.CANCEL")}
                    onClick={() => {
                      setShowModal(false);
                    }}
                  />
                </span>
                <span>
                  {!is_edit && (
                    <ButtonPrimary
                      mode="next"
                      disabled={!inputValueSpendingInfo.spending_info_month || !inputValueSpendingInfo.spending_info_value || !inputValueSpendingInfo.spending_info_year}
                      buttonName={t("ยืนยัน")}
                      onClick={() => {
                        handleAddItem();
                      }}
                    />
                  )}
                </span>
              </div>
            </div>
          }
        />
      )}

      <AccordionTable
        defaultExpanded
        required
        titleName="ข้อมูลการใช้เงิน"
        headers={fileHeaders}
        data={inputValue.spendingInfo}
        enableButtonLeft
        onClickButtonLeft={() => {
          setMode("ADD");
          setShowModal(true);
        }}
        onViewClick={(rowData) => {
          // console.log(rowData, 'rowData')
          setInputValueSpendingInfo({
            ...rowData
          })
          setMode("EDIT");
          setShowModal(true);
        }}
        onDeleteClick={handleDeleteItem}
        isView={disabled}
      />
    </>
  );
};

export default SpendingInfoForm;
